/*@flow*/
import React, { Component } from 'react';
import { Wrapper } from './style';

type Props = {
  border?: boolean,
  children: any,
  onClick?: Function,
  secondary?: boolean,
  disabled?: boolean,
  style?: Object
};

class Button extends Component<Props> {
  onClick = () => {
    const { onClick, disabled = false } = this.props;

    !disabled && onClick && onClick();
  };

  render() {
    const {
      children,
      border = true,
      secondary,
      disabled = false,
      style = {}
    } = this.props;

    const secondayClass = secondary ? 'secondary' : '';
    const secondayBorderClass = secondary ? 'bordered--secondary' : '';
    const borderClass = border ? 'bordered' : 'noborder';

    return (
      <Wrapper>
        <button
          onClick={this.onClick}
          className={`${borderClass} ${secondayClass} ${secondayBorderClass}`}
          disabled={disabled}
          style={style}
        >
          {children}
        </button>
      </Wrapper>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js